import { invalidateDocument as clearDocumentCache } from "@/lib/documentCache";
import { queryKeys } from "@/lib/cache/queryKeys";
import { queryClient } from "@/lib/cache/client";

export async function invalidateDocuments(qc = queryClient) {
  await qc.invalidateQueries({ queryKey: queryKeys.documents.all });
}

export async function invalidateDocument(qc = queryClient, id) {
  if (id) {
    clearDocumentCache(id);
    await qc.invalidateQueries({ queryKey: ["documents", id] });
  }
  await invalidateDocuments(qc);
}

export async function invalidateCases(qc = queryClient) {
  await qc.invalidateQueries({ queryKey: queryKeys.cases.all });
}

export async function invalidateCase(qc = queryClient, caseId) {
  if (caseId) {
    await qc.invalidateQueries({ queryKey: queryKeys.cases.detail(caseId) });
  }
  await invalidateCases(qc);
}

export async function invalidateConversations(qc = queryClient) {
  await qc.invalidateQueries({ queryKey: ["conversations"] });
}

export async function invalidateResearchSessions(qc = queryClient) {
  await qc.invalidateQueries({ queryKey: queryKeys.researchSessions.all });
}

export async function invalidateResearchSession(qc = queryClient, id) {
  if (id) {
    await qc.invalidateQueries({ queryKey: queryKeys.researchSessions.detail(id) });
  }
  await invalidateResearchSessions(qc);
}

export async function invalidateConversation(qc = queryClient, id) {
  if (id) {
    await qc.invalidateQueries({ queryKey: queryKeys.conversation(id) });
  }
  await invalidateConversations(qc);
}

export async function invalidateCaseDraftSuggestions(qc = queryClient, caseId) {
  if (caseId) {
    await qc.invalidateQueries({ queryKey: queryKeys.cases.detail(caseId) });
  }
}

export function prependDocument(qc = queryClient, meta) {
  qc.setQueryData(queryKeys.documents.all, (old) => {
    const list = old || [];
    return [meta, ...list.filter((d) => d.id !== meta.id)];
  });
}

export function removeDocument(qc = queryClient, id) {
  qc.setQueryData(queryKeys.documents.all, (old) => (old || []).filter((d) => d.id !== id));
}

export function updateDocumentInList(qc = queryClient, meta) {
  qc.setQueryData(queryKeys.documents.all, (old) =>
    (old || []).map((d) => (d.id === meta.id ? { ...d, ...meta } : d)),
  );
}
